<template>
  <div id="personalservice">
    <div class="personalaccount_content">
      <div class="personalaccount_content_left">
        <div class="personalaccount_content_left_item">
          <div class="personalaccount_content_left_item_head">基础功能</div>
          <div class="personalaccount_content_left_item_content">
            <div class="personalaccount_content_left_item_content_box">
              <router-link to="/shopcarIndex">我的购物车</router-link>
            </div>
            <div class="personalaccount_content_left_item_content_box">
              <router-link to="/personalOrder" class>订单管理</router-link>
            </div>
            <div class="personalaccount_content_left_item_content_box select_box">
              <router-link to="/personalservice" class="select_box">售后申请</router-link>
            </div>
            <div class="personalaccount_content_left_item_content_box">
              <router-link to="/personaCollection" class>我的收藏</router-link>
            </div>
            <div class="personalaccount_content_left_item_content_box">
              <router-link to="/personalHistory" class>浏览历史</router-link>
            </div>
          </div>
        </div>
        <div class="personalaccount_content_left_item">
          <div class="personalaccount_content_left_item_head">我的优惠信息</div>
          <div class="personalaccount_content_left_item_content">
            <div class="personalaccount_content_left_item_content_box">
              <router-link to="/personalPackage" class>我的红包</router-link>
            </div>
            <div class="personalaccount_content_left_item_content_box">
              <router-link to="/personalIntegral" class>我的积分</router-link>
            </div>
          </div>
        </div>
        <div class="personalaccount_content_left_item">
          <div class="personalaccount_content_left_item_head">发票管理</div>
          <div class="personalaccount_content_left_item_content">
            <div class="personalaccount_content_left_item_content_box">
              <router-link to="/personalTicket">申请开票</router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="personalaccount_content_right">
        <div class="personalaccount_content_right_head1">
          <div class="personalaccount_content_right_head_left">订单号：{{odernumval}}</div>
          <div class="hands" @click="$router.back(-1)">返回</div>
        </div>
        <div class="personalaccount_content_right_box">
          <div
            class="personalaccount_content_right_head marb20"
            style="padding-top:0;margin-top:0;"
          >
            <div class="personalaccount_content_right_head_left">商品列表</div>
          </div>

          <div class="personalaccount_content_right_content">
            <el-table
              :data="tableData"
              border
              style="width: 100%"
              :header-cell-style="getRowClass"
              :cell-style="cellStyle"
            >
              <el-table-column label="商品信息" width="420">
                <template slot-scope="scope">
                  <div class="tabshopimgbox flex">
                    <img :src="http + scope.row.goods_image" alt class="tabshopimg" />
                    <div class="tabshoptxt txtnowarp2">{{scope.row.goods_name}}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="goods_spec_value" label="属性"></el-table-column>
              <el-table-column label="本店价">
                <template slot-scope="scope">
                  <div class="tabshopimgbox">{{scope.row.price*1 | filterA}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="number" label="购买数量"></el-table-column>
              <el-table-column label="小计">
                <template slot-scope="scope">
                  <div
                    class="tabshopimgbox c_red"
                  >{{scope.row.price*scope.row.number*scope.row.package | filterA}}</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div>
          <div class="personalaccount_content_right_box">
            <div
              class="personalaccount_content_right_head marb20"
              style="padding-top:0;margin-top:0;"
            >
              <div class="personalaccount_content_right_head_left">售后服务选择</div>
            </div>

            <!-- 等待处理 -->
            <div class="content_item" v-show="lookinner.status==1">
              <div class="content_item_list1 flex">
                <div class="content_item_list1son1 v_active" v-show="lookinner.type==1">买家申请退款</div>
                <div class="content_item_list1son1 v_active" v-show="lookinner.type==2">买家申请换货</div>
                <div class="content_item_list1son2 v_active"></div>
                <div class="content_item_list1son1" v-show="lookinner.type==1">等待平台处理退款申请</div>
                <div class="content_item_list1son1" v-show="lookinner.type==2">等待平台处理换货申请</div>
                <div class="content_item_list1son2"></div>
                <div class="content_item_list1son1" v-show="lookinner.type==1">退款完成</div>
                <div class="content_item_list1son1" v-show="lookinner.type==2">换货完成</div>
              </div>
            </div>
            <div class="content_item" v-show="lookinner.status==1">
              <div class="content_item_list2">
                <div class="content_item_listtxt1">请等待平台的处理</div>
                <div class="content_item_listtxt2" v-show="lookinner.type==1">您已成功发起退款申请，请耐心等待平台处理</div>
                <div class="content_item_listtxt2" v-show="lookinner.type==2">您已成功发起换货申请，请耐心等待平台处理</div>
                <div class="content_item_listtxt3">您还可以直接联系客服：4000025187</div>
              </div>
            </div>
            <!-- 处理中 -->
            <div class="content_item" v-show="lookinner.status==2">
              <div class="content_item_list1 flex">
                <div class="content_item_list1son1 v_active" v-show="lookinner.type==1">买家申请退款</div>
                <div class="content_item_list1son1 v_active" v-show="lookinner.type==2">买家申请换货</div>
                <div class="content_item_list1son2 v_active"></div>
                <div class="content_item_list1son1 v_active" v-show="lookinner.type==1">平台处理退款申请</div>
                <div class="content_item_list1son1 v_active" v-show="lookinner.type==2">平台处理换货申请</div>
                <div class="content_item_list1son2 v_active"></div>
                <div class="content_item_list1son1" v-show="lookinner.type==1">退款完成</div>
                <div class="content_item_list1son1" v-show="lookinner.type==2">换货完成</div>
              </div>
            </div>
            <div class="content_item" v-show="lookinner.status==2">
              <div class="content_item_list2">
                <div class="content_item_listtxt1">平台处理中</div>
                <div class="content_item_listtxt2" v-show="lookinner.type==1">您已成功发起退款申请，请耐心等待平台处理</div>
                <div class="content_item_listtxt2" v-show="lookinner.type==2">您已成功发起换货申请，请耐心等待平台处理</div>
                <div class="content_item_listtxt3">您还可以直接联系客服：4000025187</div>
              </div>
            </div>
            <!-- //已完成 -->
            <div class="content_item" v-show="lookinner.status==3">
              <div class="content_item_list1 flex">
                <div class="content_item_list1son1 v_active" v-show="lookinner.type==1">买家申请退款</div>
                <div class="content_item_list1son1 v_active" v-show="lookinner.type==2">买家申请换货</div>
                <div class="content_item_list1son2 v_active"></div>
                <div class="content_item_list1son1 v_active" v-show="lookinner.type==1">平台处理退款申请</div>
                <div class="content_item_list1son1 v_active" v-show="lookinner.type==2">平台处理换货申请</div>
                <div class="content_item_list1son2 v_active"></div>
                <div class="content_item_list1son1 v_active" v-show="lookinner.type==1">退款完成</div>
                <div class="content_item_list1son1 v_active" v-show="lookinner.type==2">换货完成</div>
              </div>
            </div>
            <div class="content_item" v-show="lookinner.status==3">
              <div class="content_item_list2">
                <div class="content_item_listtxt1" v-show="lookinner.type==1">退款完成</div>
                <div class="content_item_listtxt1" v-show="lookinner.type==2">换货完成</div>
                <div class="content_item_listtxt2" v-show="lookinner.type==1">您的退款申请平台已审核通过</div>
                <div class="content_item_listtxt2" v-show="lookinner.type==2">您的换货申请平台已审核通过</div>
                <div class="content_item_listtxt3">{{lookinner.updated_at}}</div>
              </div>
            </div>
            <!-- //已驳回 -->
            <div class="content_item" v-show="lookinner.status==4">
              <div class="content_item_list1 flex">
                <div class="content_item_list1son1 v_active" v-show="lookinner.type==1">买家申请退款</div>
                <div class="content_item_list1son1 v_active" v-show="lookinner.type==2">买家申请换货</div>
                <div class="content_item_list1son2 v_active"></div>
                <div class="content_item_list1son1 v_active" v-show="lookinner.type==1">平台处理退款申请</div>
                <div class="content_item_list1son1 v_active" v-show="lookinner.type==2">平台处理换货申请</div>
                <div class="content_item_list1son2 v_active"></div>
                <div class="content_item_list1son1 v_active" v-show="lookinner.type==1">退款驳回</div>
                <div class="content_item_list1son1 v_active" v-show="lookinner.type==2">换货驳回</div>
              </div>
            </div>
            <div class="content_item" v-show="lookinner.status==4">
              <div class="content_item_list2">
                <div class="content_item_listtxt1" v-show="lookinner.type==1">退款失败</div>
                <div class="content_item_listtxt1" v-show="lookinner.type==2">换货失败</div>
                <div class="content_item_listtxt2" v-show="lookinner.type==1">您的退款申请平台审核未通过</div>
                <div class="content_item_listtxt2" v-show="lookinner.type==2">您的换货申请平台审核未通过</div>
                <div class="content_item_listtxt3">{{lookinner.updated_at}}</div>
              </div>
            </div>
            <!-- //已取消 -->
            <div class="content_item" v-show="lookinner.status==5">
              <div class="content_item_list1 flex">
                <div class="content_item_list1son1 v_active" v-show="lookinner.type==1">买家申请退款</div>
                <div class="content_item_list1son1 v_active" v-show="lookinner.type==2">买家申请换货</div>
                <div class="content_item_list1son2 v_active"></div>
                <div class="content_item_list1son1 v_active" v-show="lookinner.type==1">平台处理退款申请</div>
                <div class="content_item_list1son1 v_active" v-show="lookinner.type==2">平台处理换货申请</div>
                <div class="content_item_list1son2 v_active"></div>
                <div class="content_item_list1son1 v_active" v-show="lookinner.type==1">买家取消退款申请</div>
                <div class="content_item_list1son1 v_active" v-show="lookinner.type==2">买家取消换货申请</div>
              </div>
            </div>
            <div class="content_item" v-show="lookinner.status==5">
              <div class="content_item_list2">
                <div class="content_item_listtxt1" v-show="lookinner.type==1">退款完成</div>
                <div class="content_item_listtxt1" v-show="lookinner.type==2">换货完成</div>
                <div class="content_item_listtxt2" v-show="lookinner.type==1">您已取消退款申请</div>
                <div class="content_item_listtxt2" v-show="lookinner.type==2">您已取消换货申请</div>
                <div class="content_item_listtxt3">{{lookinner.updated_at}}</div>
              </div>
            </div>
          </div>

          <div
            class="content_item_list3"
            v-show="lookinner.status==1 && submitkey"
            @click="removeFu()"
          >撤销申请</div>
          <div class="content_item_list3" v-show="lookinner.status==4" @click="again()">重新申请</div>
          <div class="content_item_list3" v-show="lookinner.status==5" @click="again()">重新申请</div>

          <div class="service_footer">
            <div class="service_footer_left1">申请历史：</div>
            <div class="service_footer_right1">
              <div
                class="service_footer_right_item"
                v-show="lookinner.type==1"
              >买家({{userinner.user_name}}) 于 {{lookinner.created_at}} 创建了退款申请</div>
              <div
                class="service_footer_right_item"
                v-show="lookinner.type==2"
              >买家({{userinner.user_name}}) 于 {{lookinner.created_at}} 创建了换货申请</div>
              <div class="service_footer_right_item1 flex">
                <div class="service_footer_right_item1left">售后类型:</div>
                <div class="service_footer_right_item1right" v-show="lookinner.type==1">退货退款</div>
                <div class="service_footer_right_item1right" v-show="lookinner.type==2">换货</div>
              </div>
              <div class="service_footer_right_item1 flex" v-show="lookinner.type==1">
                <div class="service_footer_right_item1left">退款金额:</div>
                <div
                  class="service_footer_right_item1right"
                >{{ orderprice*ordernumber*orderpackage|filterA}}</div>
              </div>

              <div class="service_footer_right_item1 flex">
                <div class="service_footer_right_item1left" v-show="lookinner.type==1">退款原因:</div>
                <div class="service_footer_right_item1left" v-show="lookinner.type==2">换货原因:</div>

                <div class="service_footer_right_item1right" v-show="lookinner.cause==1">发错货</div>
                <div class="service_footer_right_item1right" v-show="lookinner.cause==2">商品损坏</div>
                <div class="service_footer_right_item1right" v-show="lookinner.cause==3">不想要了</div>
                <div class="service_footer_right_item1right" v-show="lookinner.cause==4">商品降价</div>
                <div
                  class="service_footer_right_item1right"
                  v-show="lookinner.cause==5"
                >大小/颜色/型号等不合适</div>
                <div class="service_footer_right_item1right" v-show="lookinner.cause==6">商品与页面描述不符</div>
                <div class="service_footer_right_item1right" v-show="lookinner.cause==7">缺少件</div>
                <div class="service_footer_right_item1right" v-show="lookinner.cause==8">质量问题</div>
                <div class="service_footer_right_item1right" v-show="lookinner.cause==9">其他</div>
              </div>
              <div class="service_footer_right_item1 flex">
                <div class="service_footer_right_item1left" v-show="lookinner.type==1">退款描述:</div>
                <div class="service_footer_right_item1left" v-show="lookinner.type==2">换货描述:</div>

                <div class="service_footer_right_item1right">{{lookinner.explain}}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="service_footer">
          <div class="service_footer_left">温馨提示：</div>
          <div class="service_footer_right">
            <div
              class="service_footer_right_item"
            >1、商品图片及信息仅供参考，不属质量问题；因拍摄灯光及不同显示器色差等问题可能造成商品图片与实物有色差，一切以实物为准；</div>
            <div class="service_footer_right_item">2、为不影响您的商品退换货服务，请妥善保管商品的附件、赠品、包装至少15天；</div>
            <div
              class="service_footer_right_item"
            >3、商品送货时您需与送货人员开箱验机（外观），开箱后如产品有外观缺陷附件问题的，可以直接拒收，签收后发生的外观损坏缺件等问题不予退换货；</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import DateSelect from "@/components/DateSelect";

import { regionData, CodeToText, TextToCode } from "element-china-area-data";

export default {
  name: "personalservice",
  components: {
    DateSelect
  },
  data() {
    return {
      fixedkey: false,
      tableData: [],
      oder_shopid: 0, //订单下商品id用于展示商品素材，
      orderid: 0, //订单售后ID 用于查看订单售后进度
      userid: 0,
      odernumval: "", //订单号
      fixedkey: false,
      tableData: [], //现有收获地址列表
      lookinner: "",
      orderprice: 0,
      ordernumber: 0,
      orderpackage: 0,
      submitkey: true
    };
  },
  filters: {
    //过滤器一：（使用时没有参数，即{{msg|filterA}}）
    filterA(value) {
      return "￥" + parseFloat(value.toFixed(2));
    },
    filterB(value) {
      return parseFloat(value.toFixed(2));
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  created() {
    let that = this;
    console.log("用户信息");
    console.log(that.$storage.get("user_data"));
    if (that.$storage.get("user_data") != null) {
      that.userid = that.$storage.get("user_data").user_id;
      that.userinner = that.$storage.get("user_data");
      that.odernumval = that.$route.query.odernunmber;
      that.oder_shopid = that.$route.query.shopid;
      that.orderid = that.$route.query.orderid;
    }
    that.http = that.$publicUrl.http1;
    that.getDingdan();
    that.customerlist();
  },
  methods: {
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop >= 300) {
        this.fixedkey = true;
      } else {
        this.fixedkey = false;
      }
    },
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background: #eeeeee;font-size:18px;color:#333333;text-align:center;border-right:1px solid #eeeeee;font-weight:500";
      } else {
        return "";
      }
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 5) {
        return "text-align:center;font-size:16px;color:#333333;";
      } else {
        return "text-align:center;font-size:16px;color:#333333;";
      }
    },
    handleEdit(index, row) {
      console.log(index, row);
    },
    getDingdan() {
      let that = this;
      axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        },
        url: that.$publicUrl.http1 + that.$publicUrl.getOrderSku,
        data: qs.stringify({
          user_id: that.userid,
          id: that.oder_shopid
        })
      })
        .then(function(response) {
          let data = response.data;
          if (data.stateCode == 10000) {
            that.orderprice = data.data.price;
            that.ordernumber = data.data.number;
            that.orderpackage = data.data.package;
            let nweobj = new Object();
            nweobj.goods_image = data.data.goods_image;
            nweobj.goods_name = data.data.goods_name;
            nweobj.goods_spec_value = data.data.goods_spec_value;
            nweobj.price = data.data.price;
            nweobj.number = data.data.number;
            nweobj.package = data.data.package;
            let newarr = new Array();
            newarr.push(nweobj);
            that.tableData = newarr;
          } else {
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    customerlist() {
      let that = this;
      axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        },
        url: that.$publicUrl.http1 + that.$publicUrl.order_sku_after,
        data: qs.stringify({
          id: that.orderid
        })
      })
        .then(function(response) {
          let data = response.data;

          if (data.stateCode == 10000) {
            let _data = data.data;
            that.lookinner = _data;
            console.log(_data);
          } else {
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    removeFu() {
      let that = this;
      that
        .$confirm("您将撤消此次售后申请, 是否撤消?", "系统提示", {
          confirmButtonText: "去撤消",
          cancelButtonText: "再想想",
          type: "warning"
        })
        .then(() => {
          that.removeorder();
        })
        .catch(() => {});
    },
    removeorder() {
      let that = this;
      axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        },
        url: that.$publicUrl.http1 + that.$publicUrl.ordercancel,
        data: qs.stringify({
          id: that.orderid
        })
      })
        .then(function(response) {
          let data = response.data;

          if (data.stateCode == 10000) {
            that.customerlist();
            that
              .$confirm("撤消成功, 是否返回上一步?", "系统提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              })
              .then(() => {
                that.$router.push({
                  path: "/personalservice"
                });
              })
              .catch(() => {
                that.submitkey = false;
              });
          } else {
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    again() {
      let that = this;

      that.$router.push({
        path: "/personalservicecreate",
        query: {
          shopid: that.oder_shopid,
          odernunmber: that.odernumval
        }
      });
    }
  }
};
</script>

<style scoped="scoped">
#personalservice {
  width: 100%;
  background-color: #f6f6f6;
  padding-top: 20px;
  padding-bottom: 20px;
}

.personalaccount_content {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-wrap: nowrap;
  align-items: self-start;
}

.personalaccount_content_left {
  width: 170px;
  text-align: center;
  background: #ffffff;
}

.personalaccount_content_left_item_head {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #dddddd;
  color: #333333;
  font-size: 18px;
  font-weight: 550;
}

.personalaccount_content_left_item_content {
  width: 100%;
}

.personalaccount_content_left_item_content_box {
  font-size: 16px;
  color: #333333;
  width: 100%;
  height: 40px;
  margin-top: 10px;
  line-height: 40px;
}

.select_box {
  background: #dc1e33;
  color: #ffffff;
}

.personalaccount_content_left_item_content_box span {
  color: #dc1e33;
}

.personalaccount_content_right {
  width: 1010px;
  margin-left: 20px;
}

.personalaccount_content_right_head1 {
  height: 50px;
  line-height: 50px;
  box-sizing: border-box;
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;
  background: #eeeeee;
  color: #333333;
  font-size: 18px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  margin-bottom: 30px;
}

.personalaccount_content_right_head {
  height: 50px;
  line-height: 50px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;
  color: #000000;
  background: #ffffff;
  font-size: 18px;
  border-bottom: 2px solid #dc1e33;
  margin-top: 20px;
}

.personalaccount_content_right_content {
  width: 100%;
  margin: 0 auto;
  /*margin-top: 20px;*/
  /*background: #ffffff;*/
}

.table_th {
  background: #eeeeee;
  font-size: 18px;
  color: #333333;
  text-align: center;
  border-right: 1px solid #dddddd;
  font-weight: 500;
}

.personalaccount_content_right_footer {
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 10px;
  height: 200px;
  background: #ffffff;
  margin-top: 20px;
}

.personalaccount_content_right_footer_left {
  height: calc(100% - 20px);
  line-height: 180px;
  color: #333333;
  font-size: 24px;
}

.personalaccount_content_right_footer_center {
  width: 410px;
  font-size: 16px;
  color: #333333;
  height: 180px;
  box-sizing: border-box;
  padding-top: 70px;
}

.personalaccount_content_right_content_item_lable {
  line-height: 30px;
  width: 90px;
  position: relative;
}

.personalaccount_content_right_content_item_lable span {
  display: inline-block;
  font-size: 16px;
  color: #333333;
  margin-left: 20px;
  line-height: 40px;
}

.content_item_text1 >>> .el-upload--picture-card {
  width: 120px;
  height: 120px;
  line-height: 120px;
}
.content_item_text1 >>> .el-upload-list--picture-card .el-upload-list__item {
  width: 120px !important;
  height: 120px !important;
  line-height: 120px;
}
.content_item_text1
  >>> .el-upload-list--picture-card
  .el-upload-list__item
  .el-upload-list__item-thumbnail {
  display: block;
  object-fit: scale-down;
}

.hands {
  cursor: pointer;
}
.personalaccount_content_right_box {
  width: 100%;
  padding: 20px;
  padding-top: 0;
  overflow: hidden;
  background-color: #ffffff;
  margin-bottom: 30px;
}
.marb20 {
  margin-bottom: 20px;
}
.tabshopimg {
  width: 60px;
  height: 60px;
  display: block;
  border: 1px solid #dddddd;
  margin-right: 20px;
}
.tabshoptxt {
  text-align: left;
}
.personalaccount_content_right_head_left {
  width: 750px;
}
.personalaccount_content_right_head_right {
  width: calc(100% - 750px);
  text-align: right;
  font-size: 16px;
  color: #d81023;
  cursor: pointer;
}
.content_item {
  width: 100%;
  margin: 30px auto;
}
.content_item_list1 {
  width: 100%;
  height: 50px;
  padding: 0 65px;
  align-items: center;
  justify-content: center;
}
.content_item_list1son1 {
  width: 200px;
  height: 50px;
  border: 1px dashed #cccccc;
  text-align: center;
  line-height: 50px;
  font-size: 16px;
  color: #000000;
}
.content_item_list1son2 {
  width: 100px;
  height: 1px;
  border-top: 1px dashed #cccccc;
}
.content_item_list2 {
  margin: 0 auto;
  width: 560px;
  background-color: #fe818d;
  box-sizing: border-box;
  padding: 20px;
  border-radius: 5px;
}
.content_item_listtxt1 {
  width: 100%;
  height: 35px;
  line-height: 35px;
  font-size: 20px;
  color: #ffffff;
  text-align: center;
}
.content_item_listtxt2 {
  width: 100%;
  height: 35px;
  line-height: 35px;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
}
.content_item_listtxt3 {
  width: 100%;
  height: 35px;
  line-height: 35px;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
}
.content_item_list3 {
  width: 180px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  font-size: 24px;
  color: #ffffff;
  background-color: #dc1e33;
  border-radius: 5px;
  margin: 30px auto;
  cursor: pointer;
}
.service_footer {
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: nowrap;
  background: #ffffff;
  margin: 30px auto;
  border-radius: 5px;
}
.service_footer_left {
  font-size: 18px;
  color: #d81023;
  width: 90px;
  text-align: right;
  line-height: 30px;
}
.service_footer_left1 {
  font-size: 18px;
  width: 90px;
  text-align: right;
  line-height: 30px;
}
.service_footer_right {
  font-size: 16px;
  color: #666666;
  width: calc(100% - 90px);
  line-height: 30px;
}
.service_footer_right1 {
  font-size: 16px;
  width: calc(100% - 90px);
  line-height: 30px;
}
.content_item_list1son1.v_active {
  color: #d81023;
  border: 1px dashed #d81023;
}
.content_item_list1son2.v_active {
  border-top: 1px dashed #d81023;
}
.service_footer_right_item1 {
  width: 100%;
  box-sizing: border-box;
}
.service_footer_right_item1left {
  width: 75px;
  line-height: 30px;
  height: 30px;
}
.service_footer_right_item1right {
  width: calc(100% - 105px);
}
</style>